export const validationMessages = {
  'pt-BR': {
    NAME: {
      tooLong: 'Nome muito extenso',
      format: 'Insira apenas letras',
      incomplete: 'Preencha com nome e sobrenome',
    },
    EMAIL: {
      format: 'Insira um email válido',
    },
    PHONE: {
      format:
        'Insira o DDD e um número de celular válido. Caso seja de fora do Brasil, selecione a bandeira no ícone ao lado.',
      formatEM: 'Insira o número do seu celular com DDD',
    },
    CARD_NUMBER: {
      format: 'Revise o número do cartão',
    },
    CARD_EXPIRE_DATE: {
      format: 'Revise a data de validade',
    },
    CARD_CVV: {
      format: 'Revise o código de segurança',
    },
    REGISTRY: {
      format: 'Revise este campo',
    },
    CPF: {
      format: 'Revise o CPF',
    },
    CNPJ: {
      format: 'Revise o CNPJ',
    },
    DNI: {
      format: 'Revise o DNI',
    },
    ADDRESS: {
      format: 'Insira um endereço válido',
    },
    BAIRRO: {
      format: 'Insira um bairro válido',
    },
    ESTADO: {
      format: 'Insira um estado válido',
    },
    CIDADE: {
      format: 'Insira uma cidade válida',
    },
    PAIS: {
      format: 'Insira um país válido',
    },
    CEP: {
      format: 'Insira um CEP válido',
    },
    NUMERO: {
      format: 'Insira um número válido',
    },
    COMPLEMENTO: {
      format: 'Insira um complemento válido',
    },
    REQUIRED: 'Este campo é obrigatório',
  },
  'es-PE': {
    NAME: {
      tooLong: 'Nombre muy extenso',
      format: 'Ingrese solo letras',
      incomplete: 'Complete con nombre y apellido',
    },
    EMAIL: {
      format: 'Ingrese un correo electrónico válido',
    },
    PHONE: {
      format:
        'Ingrese el código de área y un número de teléfono móvil válido. Si es de fuera de Perú, seleccione la bandera en el ícono al lado.',
      formatEM: 'Ingrese su número de teléfono móvil con código de área',
    },
    CARD_NUMBER: {
      format: 'Revise el número de tarjeta',
    },
    CARD_EXPIRE_DATE: {
      format: 'Revise la fecha de vencimiento',
    },
    CARD_CVV: {
      format: 'Revise el código de seguridad',
    },
    REGISTRY: {
      format: 'Revise este campo',
    },
    CPF: {
      format: 'Revise el CPF',
    },
    CNPJ: {
      format: 'Revise el CNPJ',
    },
    DNI: {
      format: 'Revise el DNI',
    },
    ADDRESS: {
      format: 'Ingrese una dirección válida',
    },
    BAIRRO: {
      format: 'Ingrese un distrito válido',
    },
    ESTADO: {
      format: 'Ingrese un departamento válido',
    },
    CIDADE: {
      format: 'Ingrese una ciudad válida',
    },
    PAIS: {
      format: 'Ingrese un país válido',
    },
    CEP: {
      format: 'Ingrese un código postal válido',
    },
    NUMERO: {
      format: 'Ingrese un número válido',
    },
    COMPLEMENTO: {
      format: 'Ingrese un complemento válido',
    },
    REQUIRED: 'Este campo es obligatorio',
  },
};
